import format from 'date-fns/format'
import isValid from 'date-fns/isValid'
import parseISO from 'date-fns/parseISO'
import { SearchParamsKeys } from 'src/enums'

export const ORDER_DATE_PARAM_FORMAT = 'yyyy-MM-dd'

export const parseOrderDateParam = (value?: string | null): Date | null => {
  if (!value) return null
  const date = parseISO(value)
  return isValid(date) ? date : null
}

// Returns query params only when the range is complete — a half-picked range must not hit the API
export const buildOrderDateRangeQueryValues = (dateFrom?: Date | null, dateTo?: Date | null): Record<string, string> | null => {
  if (!dateFrom || !dateTo || !isValid(dateFrom) || !isValid(dateTo)) return null
  return {
    [SearchParamsKeys.OrderDateFrom]: format(dateFrom, ORDER_DATE_PARAM_FORMAT),
    [SearchParamsKeys.OrderDateTo]: format(dateTo, ORDER_DATE_PARAM_FORMAT)
  }
}
